module.exports = __webpack_public_path__ + "img/sports.efd45504.png";